(() => {
  const selector = '[data-kdeport-invoice]';

  function bindInvoiceForm(root) {
    if (!root || root.dataset.invoiceReady === 'true') return;
    root.dataset.invoiceReady = 'true';

    const requestedChoice = root.querySelector('[data-invoice-choice="requested"]');
    const consumerChoice = root.querySelector('[data-invoice-choice="consumer"]');
    const details = root.querySelector('[data-invoice-details]');
    const controls = Array.from(root.querySelectorAll('[data-invoice-control]'));
    const clearInputs = Array.from(root.querySelectorAll('[data-invoice-clear]'));
    const error = root.querySelector('[data-invoice-error]');

    if (!requestedChoice || !consumerChoice || !details) return;

    function syncInvoiceChoice() {
      const wantsInvoice = requestedChoice.checked;

      details.hidden = !wantsInvoice;
      details.setAttribute('aria-hidden', String(!wantsInvoice));

      controls.forEach((control) => {
        control.disabled = !wantsInvoice;
        control.required = wantsInvoice && control.type !== 'hidden';
      });

      clearInputs.forEach((input) => {
        input.disabled = wantsInvoice;
      });

      if (error) error.hidden = true;
    }

    [consumerChoice, requestedChoice].forEach((input) => {
      input.addEventListener('change', syncInvoiceChoice);
    });

    const formId = requestedChoice.getAttribute('form');
    const form = formId ? document.getElementById(formId) : requestedChoice.form;

    if (form && form.dataset.invoiceValidationBound !== 'true') {
      form.dataset.invoiceValidationBound = 'true';
      form.addEventListener('submit', (event) => {
        const activeRoot = document.querySelector(`${selector} input[form="${form.id}"]`)?.closest(selector) || root;
        const selectedChoice = activeRoot.querySelector('[data-invoice-choice]:checked');
        const activeError = activeRoot.querySelector('[data-invoice-error]');

        if (!selectedChoice) {
          event.preventDefault();
          if (activeError) activeError.hidden = false;
          activeRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
          activeRoot.querySelector('[data-invoice-choice]')?.focus();
        }
      });
    }

    syncInvoiceChoice();
  }

  function initInvoiceForms(scope = document) {
    if (scope.matches?.(selector)) bindInvoiceForm(scope);
    scope.querySelectorAll?.(selector).forEach(bindInvoiceForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initInvoiceForms(), { once: true });
  } else {
    initInvoiceForms();
  }

  document.addEventListener('shopify:section:load', (event) => initInvoiceForms(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initInvoiceForms(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
